export const ContractPriceType = {
    ACCOMODATION: 0,
    ACTIVITY: 1,
    RESTAURATION: 2,
    SERVICE: 3,
    TRANSPORT: 4
};